// Where a league opens, for the places that open one from outside it: the
// hub's league cards and the league switcher (scenario L3, B-247).
//
// NOT THE LEAGUE'S OWN ADDRESS. `/l/<id>` is My Team, and the My Team tab
// links there, so the choice cannot be a redirect from it — My Team would
// become unreachable for anybody who chose another screen. It is where the
// doors INTO a league point instead. A league still in setup opens on its
// Home, the draft and the invite, whatever was chosen.

import type { OpensOn } from '@fsp/domain';
import { useAccountPrefs } from './accountPrefs';

export function leagueEntry(
  leagueId: string,
  setup: boolean,
  opensOn: Readonly<Record<string, OpensOn>> | undefined,
): string {
  const base = `/l/${leagueId}`;
  if (setup) return base;
  switch (opensOn?.[leagueId]) {
    case 'matchup':
      return `${base}/matchup`;
    case 'scores':
      return `${base}/scoreboard`;
    case 'players':
      return `${base}/players`;
    case 'league':
      return `${base}/league`;
    default:
      return base;
  }
}

/** `leagueEntry` with the account's choices. */
export function useLeagueEntry(): (leagueId: string, setup: boolean) => string {
  const { account } = useAccountPrefs();
  return (leagueId, setup) => leagueEntry(leagueId, setup, account?.opensOn);
}
